/**
 * MediaControlsFeature - Mute all media on the page
 */
import BaseFeature from './BaseFeature.js';

export default class MediaControlsFeature extends BaseFeature {
    constructor(widget, options = {}) {
        super(widget, options);
        this._originalStates = [];
    }

    enable() {
        super.enable();
        this._muteAll();
        this.addBodyClass('dhA11y-mute-media');
    }

    disable() {
        super.disable();
        this._restoreAll();
        this.removeBodyClass('dhA11y-mute-media');
    }

    /**
     * Mute all audio and video elements
     */
    _muteAll() {
        const media = document.querySelectorAll('audio, video');
        this._originalStates = [];
        media.forEach(el => {
            this._originalStates.push({ el, muted: el.muted, volume: el.volume });
            el.muted = true;
        });

        // Also handle iframes (YouTube, etc.) by hiding them
        const iframes = document.querySelectorAll('iframe[src*="youtube"], iframe[src*="vimeo"]');
        iframes.forEach(iframe => {
            iframe.dataset.a11yOriginalSrc = iframe.src;
            // Add mute parameter
            const url = new URL(iframe.src);
            url.searchParams.set('mute', '1');
            iframe.src = url.toString();
        });
    }

    /**
     * Restore original media states
     */
    _restoreAll() {
        this._originalStates.forEach(({ el, muted, volume }) => {
            el.muted = muted;
            el.volume = volume;
        });
        this._originalStates = [];

        // Restore iframes
        const iframes = document.querySelectorAll('iframe[data-a11y-original-src]');
        iframes.forEach(iframe => {
            iframe.src = iframe.dataset.a11yOriginalSrc;
            delete iframe.dataset.a11yOriginalSrc;
        });
    }
}
